import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';

import { AddClientGroupForm, clientGroupSchema } from '@t/user/components/clientGroupFilter/field-values.schema';

export const useCreateAddClientGroup = () => {
  const methods = useForm<AddClientGroupForm>({
    mode: 'onChange',
    resolver: zodResolver(clientGroupSchema),
    reValidateMode: 'onChange',
  });

  return methods;
};
